<template>
  <Autocomplete
    v-model="value"
    v-attributes="schema.attributes"
    class="field-collections"
    open-on-focus
    :disabled="schema.disabled"
    icon="database"
    :data="collections"
  />
</template>
<script>
import { abstractField } from 'vue-form-generator';
import { mapState } from 'vuex';
import Autocomplete from '@/components/ui/Autocomplete';

export default {
  components: {
    Autocomplete,
  },
  mixins: [abstractField],
  computed: {
    ...mapState({
      panels: (state) => state.abstractElements.objects.panels.objects,
    }),
    collections() {
      const collectionsObjects = {};
      for (const p of this.panels) {
        collectionsObjects[p.collection] = true;
      }

      return Object.keys(collectionsObjects);
    },
  },
};
</script>
<style scoped>
.field-collections {
  width: 100%;
}
</style>
